module.exports = __webpack_public_path__ + "img/personalEn.847515d6.jpg";